import { Component, OnInit } from '@angular/core';
import { NgForm, FormGroup } from '@angular/forms';
import { Office } from '../../../shared/user.model';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { RegistrationService } from '../../../registration.service';

@Component({
  selector: 'app-office-form',
  templateUrl: './office-form.component.html',
  styleUrls: ['./office-form.component.css']
})
export class OfficeFormComponent implements OnInit {
  
  maintitle="Office";
  office:any ={};
  formSubmitted: boolean;
  OfficeId:string;
  mode:string;
  data:any;
  DistrictList;
officelevellist;
title="Add Office";
  Offdistict: any;
  constructor(private router: Router, private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) {
    this.OfficeId=null;
    this.mode=null;
    this.office=new Office();
    this.formSubmitted = false;
   }

  ngOnInit() {
  this.GetAllDistrictNames();
  this.GetAllOfficelevels();
  
    // this.route.params.subscribe(params =>
    //   this.OfficeId = params['OfficeId']
    // );
    // this.route.params.subscribe(params =>
    //   this.mode = params['mode']
    // );

    //From URL
    this.mode=localStorage.getItem('mode');
    this.OfficeId= localStorage.getItem('officeId');
    localStorage.removeItem('officeId'); 
    localStorage.removeItem('mode');
    
    if (this.OfficeId != null && this.mode!=null) 
      this.GetOfficeForTheId(this.OfficeId);
  }


  GetAllDistrictNames() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllDistrictNames();
    this.data.subscribe(
      (response) => {
        this.DistrictList = response;
        document.getElementById('loader-spinner').style.display = "none";
        
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }


  GetAllOfficceDistrictNames(id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllDistrictNamesListgrid2(id);
    this.data.subscribe(
      (response) => {
        this.Offdistict = response;
        document.getElementById('loader-spinner').style.display = "none";
        
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  // this.data = this.userService.GetAllDistrictNamesListgrid2(id);
  // this.data.subscribe(
  //   (response: any) => {
  //     this.Offdistict = response.Result;

  GetAllOfficelevels() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllOfficelevels();
    this.data.subscribe(
      (response) => {
        this.officelevellist = response;
        document.getElementById('loader-spinner').style.display = "none";
        
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }


  GetOfficeForTheId(OfficeId) {
   
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getOfficeForTheId(OfficeId)
      .subscribe(
        (data) => {
          this.office = data;
          this.GetAllOfficceDistrictNames(this.office.Id);
          if( this.office.Off_pincode==0)
          {this.office.Off_pincode='';}
          //this.isUpdate=true;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  update(form: NgForm) {
    if (!form.invalid) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.updateOffice(form.value,this.OfficeId)
      .subscribe(
        (data) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('','Updated Successfully!','success');
          this.router.navigate(['/home/office']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
          //swal('Warning!', error.error.Message, 'warning');
        });
      }else{
        document.getElementById('loader-spinner').style.display = "none";
        swal('warning','Please fill all the mandatory fields!','warning');
        this.formSubmitted = true;

        }
  }

    onSubmit(form: NgForm) {
      
      if (!form.invalid) {
        
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.CreateOffice(form.value)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            swal('','Saved Successfully!','success');
            this.router.navigate(['/home/office']);
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            //this.errorHandler.HandlerError(error);
            swal('Warning!', error.error.Message, 'warning');
          });
        }else{          
        document.getElementById('loader-spinner').style.display = "none";
        this.formSubmitted = true;
        }
    }

    
}        



// WEBPACK FOOTER //
// ./src/app/ultilities/office/office-form/office-form.component.ts